export default function limpaNull(
  variavel: string | undefined,
  text?: string,
): string {
  if (!variavel) return '';
  if (!text) return variavel;
  return text;
}
